import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BannerModule } from '@sb/library/banner';
import { BaseModule } from '@sb/library/base';
import { ButtonModule } from '@sb/library/button';
import { DialogModule } from '@sb/library/dialog';
import { DragAndDropModule } from '@sb/library/drag-and-drop';
import { EmptyStateModule } from '@sb/library/empty-state';
import { FormFieldModule } from '@sb/library/form-field';
import { IconModule } from '@sb/library/icon';
import { LayoutModule } from '@sb/library/layout';
import { ListModule } from '@sb/library/list';
import { LocalizationModule } from '@sb/library/localization';
import { StatusLabelModule } from '@sb/library/status-label';
import { AddPaymentSourceComponent } from './add/add-payment-source.component';
import { PaymentSourcesAddPayPalComponent } from './add/paypal/payment-sources-add-paypal.component';
import { PaymentSourcesAddPaypalProComponent } from './add/paypal-pro/payment-sources-add-paypal-pro.component';
import { PaymentSourcesAddStripeComponent } from './add/stripe/payment-sources-add-stripe.component';
import { PaymentSourcesComponent } from './payment-sources/payment-sources.component';
import { PaymentPageComponent } from './payment-page/payment-page.component';
import { PaymentIssuerIconPipe } from './pipes/payment-issuer-icon.pipe';
import { PaymentSourceIconPipe } from './pipes/payment-source-icon.pipe';
import { PaymentErrorDialogComponent } from './dialogs/payment-error-dialog.component';
import { SubmissionBarModule } from '@sb/library/submission-bar';
import { CardModule } from '@sb/library/card';
import { ExpansionCardModule } from '@sb/library/expansion-card';
import { UtilityModule } from '@sb/library/utility';
import { SvgComponent } from '@sb/library/svg';

@NgModule({
    declarations: [
        PaymentSourcesComponent,
        PaymentPageComponent,
        PaymentSourceIconPipe,
        PaymentIssuerIconPipe,
        AddPaymentSourceComponent,
        PaymentSourcesAddPaypalProComponent,
        PaymentSourcesAddStripeComponent,
        PaymentSourcesAddPayPalComponent,
        PaymentErrorDialogComponent
    ],
    imports: [
        CommonModule,
        CardModule,
        ExpansionCardModule,
        DragAndDropModule,
        StatusLabelModule,
        ButtonModule,
        IconModule,
        EmptyStateModule,
        DialogModule,
        ReactiveFormsModule,
        FormFieldModule,
        MatTooltipModule,
        BannerModule,
        LocalizationModule,
        BaseModule,
        LayoutModule,
        ListModule,
        SubmissionBarModule,
        UtilityModule,
        SvgComponent
    ],
    exports: [
        PaymentSourcesComponent,
        PaymentPageComponent,
        AddPaymentSourceComponent,
        PaymentErrorDialogComponent
    ]
})
export class PaymentsModule { }
